import api from "../../utilities/Interceptor";
import { decrypt } from "../../utilities/Encriptacion";

const url = process.env.REACT_APP_API_KEY

interface stroke {
    name: string;
    time1: string;
    time2: string;
    time3: string,
    comments: string
}
export interface IItinerary {
    name: string;
    stroke: stroke[]
}

const getClientId = (): number => {
    const CLAVE = process.env.REACT_APP_CLAVE_ENCRYPTION!;
    const encryptedData = sessionStorage.getItem('dataClient');
    const data = decrypt(encryptedData, CLAVE);
    return JSON.parse(data).id;
}

export const getItinerary = async (idRuta: number, type: string): Promise<IItinerary> => {
    const res = await api.get<IItinerary>(`${url}/maps/newItinerary?id_ruta=${idRuta}&type=${type}`);
    return res.data;
}

export const getOldItinerary = async (id: number): Promise<IItinerary> => {
    const res = await api.get<IItinerary>(`${url}/maps/itinerary/${id}`);
    return res.data;
}

export const getRoutes = async (): Promise<any> => {
    const res = await api.get(`${url}/maps/routesByClient/${getClientId()}`);
    return res.data;
}

export const getOldRoutes = async (): Promise<any> => {
    const res = await api.get(`${url}/maps/oldRoutesByClient/${getClientId()}`);
    return res.data;
}
